module.exports = __webpack_public_path__ + "img/IMG_0497.76e9ef39.76e9ef39.jpeg";